<script lang="ts" setup>
	import dayjs from 'dayjs'
	import type { PolicyResponse } from '~/types/Purchase'

	const props = defineProps<{
		metaDetails: RecordSchema
		premium?: string
		isDeactivated: boolean
		isPending: boolean
		isExpired: boolean
	}>()

	defineEmits<{
		(event: 'activate'): void
		(event: 'reminder'): void
	}>()

	const downloadingHmo = shallowRef(false)
	const statusMessage = computed(() => {
		const message = reactive({
			title: 'No Travel Detail',
			subTitle: 'This travel plan has not been activated yet. Activate now to enjoy full benefits.'
		})
		if (props.isDeactivated) {
			message.title = 'Travel Plan Deactivate'
			message.subTitle = 'This travel plan has been deactivated'
		}

		return message
	})
	const policy = computed(() => props.metaDetails as PolicyResponse)
	const policyDetails = computed(() => {
		return {
			'Next of kin first name': policy.value?.meta?.nok_full_name,
			'Next of kin last name': policy.value?.meta?.destination || '',
			'Next of kin email address': policy.value?.meta?.nok_address || '',
			'Next of kin phone number': policy.value?.meta?.nok_phone_number,
			'Relationship to next of kin': policy.value?.meta?.nok_relationship,
			'Date Added':
				policy.value?.policy_start_date && dayjs(policy.value.policy_start_date).format('DD MMM, YYYY')
		}
	})
</script>

<template>
	<div>
		<my-cover-policy-label
			label="Next of kin details of staff"
			:icon="{ name: 'group-profile', dir: 'other', pathClass: 'fill-primary-2 ' }"
			class="mb-5"
		/>
		<my-cover-pending-policy-placeholder
			icon-dir="documents"
			:title="statusMessage.title"
			:sub-title="statusMessage.subTitle"
			icon-name="clipboard-document-2"
			:is-pending="isPending || isDeactivated"
			activate-text="Activate Staff"
			:use-btn="!isDeactivated"
			@activate="$emit('activate')"
			@reminder="$emit('reminder')"
		>
			<template #button-group>
				<div></div>
			</template>
		</my-cover-pending-policy-placeholder>
		<my-cover-policy-card
			v-if="!isPending && !isDeactivated"
			:details="policyDetails"
			:downloading="downloadingHmo"
		>
		</my-cover-policy-card>
	</div>
</template>
